/* =========================================================
   RS · JS compartido de la landing de producto (clon PDP)
   - Carga Swiper una sola vez (asset del tema)
   - Registra inits por sección y los relanza en el editor de temas
   - Comportamientos genéricos por data-attribute:
       [data-rs-faq]        acordeones
       [data-rs-video]      vídeo con botón de play
       [data-rs-countup]    contadores animados
       [data-rs-marquee]    marquesinas infinitas (clona hasta 2x el viewport)
       [data-rs-milestones] línea temporal que se activa al hacer scroll
   ========================================================= */
(function () {
  if (window.RS && window.RS.__loaded) return;

  var RS = window.RS = window.RS || {};
  RS.__loaded = true;
  RS.__inits = {};

  var script = document.currentScript || document.querySelector('script[data-rs-swiper-js]');
  var swiperJs = script && script.getAttribute('data-rs-swiper-js');
  var swiperCss = script && script.getAttribute('data-rs-swiper-css');

  /* ---------- Swiper loader (una sola vez) ---------- */
  var swiperPromise = null;
  RS.swiper = function () {
    if (swiperPromise) return swiperPromise;
    swiperPromise = new Promise(function (resolve, reject) {
      if (typeof window.Swiper === 'function') return resolve(window.Swiper);
      if (swiperCss && !document.querySelector('link[data-rs-swiper-css]')) {
        var l = document.createElement('link');
        l.rel = 'stylesheet';
        l.href = swiperCss;
        l.setAttribute('data-rs-swiper-css', '');
        document.head.appendChild(l);
      }
      var existing = document.querySelector('script[data-rs-swiper-runtime]');
      if (existing) {
        existing.addEventListener('load', function () { resolve(window.Swiper); });
        existing.addEventListener('error', reject);
        return;
      }
      var s = document.createElement('script');
      s.src = swiperJs;
      s.setAttribute('data-rs-swiper-runtime', '');
      s.onload = function () { resolve(window.Swiper); };
      s.onerror = function () { reject(new Error('RS: no se pudo cargar Swiper')); };
      document.head.appendChild(s);
    });
    return swiperPromise;
  };

  /* ---------- Registro de secciones ---------- */
  function domReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  RS.section = function (sectionId, opts, init) {
    if (typeof opts === 'function') { init = opts; opts = {}; }
    opts = opts || {};
    var run = function () {
      var root = document.getElementById('shopify-section-' + sectionId);
      if (!root) return;
      RS.behaviours(root);
      var go = function (Swiper) {
        try { init(root, Swiper); } catch (e) { console.error('[RS] ' + sectionId, e); }
      };
      if (opts.swiper) RS.swiper().then(go).catch(function (e) { console.error(e); });
      else go();
    };
    RS.__inits[sectionId] = run;
    domReady(run);
  };

  document.addEventListener('shopify:section:load', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (id && RS.__inits[id]) RS.__inits[id]();
    else if (e.target) RS.behaviours(e.target);
  });

  /* ---------- Comportamientos genéricos ---------- */
  RS.behaviours = function (root) {
    root = root || document;
    initFaq(root);
    initVideo(root);
    initCountup(root);
    initMarquee(root);
    initMilestones(root);
  };

  function initFaq(root) {
    root.querySelectorAll('[data-rs-faq]').forEach(function (group) {
      if (group.__rs) return;
      group.__rs = true;
      var exclusive = group.getAttribute('data-rs-faq') !== 'multi';
      group.addEventListener('click', function (e) {
        var q = e.target.closest('.rs-faq__q');
        if (!q || !group.contains(q)) return;
        var item = q.closest('.rs-faq');
        var open = item.classList.contains('is-open');
        if (exclusive) {
          group.querySelectorAll('.rs-faq.is-open').forEach(function (o) {
            o.classList.remove('is-open');
            var t = o.querySelector('.rs-faq__toggle'); if (t) t.textContent = '+';
            var b = o.querySelector('.rs-faq__q'); if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        if (!open) {
          item.classList.add('is-open');
          q.setAttribute('aria-expanded', 'true');
          var tg = item.querySelector('.rs-faq__toggle'); if (tg) tg.textContent = '−';
        } else if (!exclusive) {
          item.classList.remove('is-open');
          q.setAttribute('aria-expanded', 'false');
          var tg2 = item.querySelector('.rs-faq__toggle'); if (tg2) tg2.textContent = '+';
        }
      });
    });
  }

  function initVideo(root) {
    root.querySelectorAll('[data-rs-video]').forEach(function (wrap) {
      if (wrap.__rs) return;
      wrap.__rs = true;
      var video = wrap.querySelector('video');
      var btn = wrap.querySelector('.rs-video__play');
      if (!video) return;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.removeAttribute('autoplay');
      video.controls = false;
      var stopOthers = function () {
        document.querySelectorAll('[data-rs-video] video').forEach(function (v) {
          if (v !== video) {
            v.pause();
            v.controls = false;
            var w = v.closest('[data-rs-video]');
            if (w) w.classList.remove('is-playing');
          }
        });
      };
      var play = function () {
        stopOthers();
        video.muted = false;
        video.play().then(function () {
          wrap.classList.add('is-playing');
          video.controls = true;
        }).catch(function () {
          video.muted = true;
          video.play();
          wrap.classList.add('is-playing');
          video.controls = true;
        });
      };
      if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); play(); });
      video.addEventListener('pause', function () {
        wrap.classList.remove('is-playing');
        video.controls = false;
      });
      video.addEventListener('ended', function () {
        wrap.classList.remove('is-playing');
        video.controls = false;
      });
    });
  }

  function parseTarget(raw) {
    raw = (raw || '').trim();
    var m = raw.match(/^(\D*)([\d.,\s]+)(.*)$/);
    if (!m) return null;
    var prefix = m[1] || '';
    var numStr = m[2].replace(/[\s]/g, '');
    var suffix = m[3] || '';
    // Soporta "7.000" (miles con punto) y "2,000" (miles con coma) y decimales "4,9"/"4.9"
    var decimals = 0, thousands = '.';
    var value;
    if (/^\d{1,3}([.,]\d{3})+$/.test(numStr)) {
      thousands = numStr.indexOf('.') > -1 ? '.' : ',';
      value = parseInt(numStr.replace(/[.,]/g, ''), 10);
    } else if (/^\d+[.,]\d+$/.test(numStr)) {
      var sep = numStr.indexOf(',') > -1 ? ',' : '.';
      decimals = numStr.split(sep)[1].length;
      thousands = sep === ',' ? '.' : ',';
      value = parseFloat(numStr.replace(',', '.'));
    } else {
      value = parseInt(numStr.replace(/[.,]/g, ''), 10);
    }
    if (isNaN(value)) return null;
    var fmt = function (v) {
      var s = decimals ? v.toFixed(decimals) : Math.round(v).toString();
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals ? parts[0] + (thousands === '.' ? ',' : '.') + parts[1] : parts[0];
    };
    return { prefix: prefix, value: value, suffix: suffix, fmt: fmt };
  }

  function initCountup(root) {
    var els = root.querySelectorAll('[data-rs-countup]');
    if (!els.length) return;
    els.forEach(function (el) {
      if (el.__rs) return;
      el.__rs = true;
      var t = parseTarget(el.getAttribute('data-rs-countup') || el.textContent);
      if (!t) return;
      el.__target = t;
      el.textContent = t.prefix + t.fmt(0) + t.suffix;
    });
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { if (el.__target) el.textContent = el.__target.prefix + el.__target.fmt(el.__target.value) + el.__target.suffix; });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target, t = el.__target;
        obs.unobserve(el);
        if (!t || el.__done) return;
        el.__done = true;
        var dur = t.value <= 100 ? 1000 : 1800, start = performance.now();
        var ease = function (x) { return 1 - (1 - x) * (1 - x); };
        var step = function (now) {
          var p = Math.min((now - start) / dur, 1);
          el.textContent = t.prefix + t.fmt(ease(p) * t.value) + t.suffix;
          if (p < 1) requestAnimationFrame(step); else el.textContent = t.prefix + t.fmt(t.value) + t.suffix;
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.3 });
    els.forEach(function (el) { if (el.__target && !el.__done) io.observe(el); });
  }

  function initMarquee(root) {
    root.querySelectorAll('[data-rs-marquee]').forEach(function (track) {
      if (track.__rs) return;
      track.__rs = true;
      var items = Array.prototype.slice.call(track.children);
      if (!items.length) return;
      var origLen = items.length;
      var safety = 30;
      var need = Math.max(window.innerWidth * 2, 1200);
      while (track.scrollWidth < need && safety-- > 0) {
        items.forEach(function (it) { track.appendChild(it.cloneNode(true)); });
      }
      var sets = track.children.length / origLen;
      track.style.setProperty('--rs-marquee-end', '-' + (100 / sets).toFixed(4) + '%');
    });
  }

  function initMilestones(root) {
    root.querySelectorAll('[data-rs-milestones]').forEach(function (list) {
      if (list.__rs) return;
      list.__rs = true;
      var items = list.querySelectorAll('.rs-milestone');
      var update = function () {
        var vh = window.innerHeight;
        items.forEach(function (it) {
          var r = it.getBoundingClientRect();
          // Se activa cuando el bloque ha subido 200px por encima del borde inferior
          if (r.bottom + 200 <= vh) it.classList.add('is-active');
          else it.classList.remove('is-active');
        });
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Fecha de entrega estimada ---------- */
  RS.deliveryDate = function (el) {
    var days = parseInt(el.getAttribute('data-rs-days') || '3', 10);
    var d = new Date();
    d.setDate(d.getDate() + days);
    var locale = el.getAttribute('data-rs-locale') || document.documentElement.lang || 'es';
    try {
      el.textContent = d.toLocaleDateString(locale, { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, '').replace(/^\w/, function (c) { return c.toUpperCase(); });
    } catch (e) {
      el.textContent = d.toLocaleDateString();
    }
  };

  domReady(function () {
    RS.behaviours(document);
    document.querySelectorAll('[data-rs-days]').forEach(RS.deliveryDate);
    var q = window.RSQ || [];
    while (q.length) { try { q.shift()(RS); } catch (e) { console.error(e); } }
    window.RSQ = { push: function (fn) { try { fn(RS); } catch (e) { console.error(e); } } };
  });
})();
